import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchClientNudges } from "../../../services/accIqService";
import { FETCH_CLIENT_NUDGE_REQUEST, fetchClientNudgeFailure, fetchClientNudgeSuccess } from "../actions/clientNudgeActions";

// Worker Saga
function* fetchClientNudgeDataSaga() {
  try {
    const payload = yield select(
      (state) => state?.clientNudgeReducer?.payload
    );
    const { clientNameNew } = payload;

    const data = yield call(
        fetchClientNudges,clientNameNew
    );
    yield put(fetchClientNudgeSuccess(data));
  } catch (error) {
    yield put(fetchClientNudgeFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchClientNudgeData() {
  yield takeLatest(FETCH_CLIENT_NUDGE_REQUEST, fetchClientNudgeDataSaga);
}
